import * as React from 'react';
import { connect } from 'react-redux';
import { Route, Switch } from 'react-router';
import { Spin } from 'antd';
import { AppState } from '../../reducers';
import CounterpartyList from './CounterpartyList';

class Counterparty extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
  }

  public render() {
    const {loading} = this.props;
    return (
      <Spin spinning={ loading }>
        <Switch>
          <Route exact path="/counterparty/list" component={CounterpartyList}/>
        </Switch>
      </Spin>
    );
  }
}

const mapStateToProps = (state: AppState) => ({
  loading: state.counterparty.loading,
});

export default connect(mapStateToProps)(Counterparty);
